import { DateFnsI18n } from '../types';

export const dateFnsI18n: DateFnsI18n = {
  // eslint-disable-next-line @typescript-eslint/typedef
  lv: () => import('date-fns/locale/lv').then((mod) => mod.lv),
  // eslint-disable-next-line @typescript-eslint/typedef
  ru: () => import('date-fns/locale/ru').then((mod) => mod.ru)
};
